import React from "react";
import { Squares2X2Icon, Bars3Icon } from "@heroicons/react/24/solid";

const GridListToggle = ({ viewMode, onChange }) => {
  return (
    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden p-1">
      {/* Grid View Button */}
      <button
        onClick={() => onChange("grid")}
        className={`p-2 flex items-center justify-center transition-colors rounded ${
          viewMode === "grid"
            ? "bg-blue-500 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        <Squares2X2Icon className="w-5 h-5" />
      </button>

      {/* List View Button */}
      <button
        onClick={() => onChange("list")}
        className={`p-2 flex items-center justify-center transition-colors rounded ${
          viewMode === "list"
            ? "bg-blue-500 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        <Bars3Icon className="w-5 h-5" />
      </button>
    </div>
  );
};

export default GridListToggle;
